import script from "./_ql-live-stream.vue?vue&type=script&setup=true&lang=ts"
export * from "./_ql-live-stream.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__